import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagUtilService {
  private serviceSubject :BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor() {}

  setService(service :any) :void {
    this.serviceSubject.next(service);
  }

  isFeatureEnabled(featureName :string) :boolean {
    const service = this.serviceSubject.getValue();

    return service?.featureEnabled(featureName) || false;
  }
}
